import {diff} from 'deep-diff';
import {log as logToServer} from '../api/logger';

function pricingHelperQueryComparator({
    graphqlPricingArgs,
    graphqlPricingResult,
    graphqlQuoteArgs,
    graphqlQuoteResult,
    isLoggedIn
}) {
    let differences;
    let logEntry;
    if (
        graphqlPricingResult.priceDetails &&
        graphqlQuoteResult.quote &&
        graphqlQuoteResult.quote.priceDetails
    ) {
        differences = diff(
            graphqlPricingResult.priceDetails,
            graphqlQuoteResult.quote.priceDetails
        );
    }
    if (Array.isArray(differences) && differences.length > 0) {
        logEntry = {
            message: 'priceDetails.comparison',
            summary: `${differences.length} differences found`,
            differences,
            graphqlPricingArgs,
            graphqlQuoteArgs,
            isLoggedIn
        };
        logToServer(logEntry);
    }
}

export default pricingHelperQueryComparator;
